import {useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {SettingService} from "./Service";
import {toast} from "react-hot-toast";
import store from "../../core/store";
import {loadPreferences} from "../../core/store/company/reducers";

const PreferenceSettings = () => {
    const [service] = useState(new SettingService());
    const preferences = useSelector((state: any) => state.company.preferences);
    const [tcs, setTcs] = useState(preferences.tcs);
    const [tds, setTds] = useState(preferences.tds);
    const [transportation, setTransportation] = useState(preferences.transportationCharge);
    const [labour, setLabour] = useState(preferences.labourCharge);
    const [quantity, setQuantity] = useState(preferences.quantity);
    const [invoiceNumber, setInvoiceNumber] = useState(preferences.invoiceNumber);
    const [purchaseNumber, setPurchaseNumber] = useState(preferences.purchaseNumber);
    const [creditNoteNumber, setCreditNoteNumber] = useState(preferences.creditNoteNumber);
    const [debitNoteNumber, setDebitNoteNumber] = useState(preferences.debitNoteNumber);
    const [receiptVoucherNumber, setReceiptVoucherNumber] = useState(preferences.receiptVoucherNumber);
    const [paymentVoucherNumber, setPaymentVoucherNumber] = useState(preferences.paymentVoucherNumber);
    const [dueDays, setDueDays] = useState(preferences.dueDays);

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        const data = {
            tcs,
            tds,
            transportationCharge: transportation,
            labourCharge: labour,
            quantity,
            invoiceNumber,
            purchaseNumber,
            creditNoteNumber,
            debitNoteNumber,
            receiptVoucherNumber,
            paymentVoucherNumber,
            dueDays
        };
        const res = await service.updatePreferences(data);
        if (res) {
            toast.success('Preferences updated successfully');
            store.dispatch({
                type: loadPreferences,
                payload: res
            });
        }
    }

    useEffect(() => {
        setTcs(preferences.tcs);
        setTds(preferences.tds);
        setTransportation(preferences.transportationCharge);
        setLabour(preferences.labourCharge);
        setQuantity(preferences.quantity);
        setInvoiceNumber(preferences.invoiceNumber);
        setPurchaseNumber(preferences.purchaseNumber);
        setCreditNoteNumber(preferences.creditNoteNumber);
        setDebitNoteNumber(preferences.debitNoteNumber);
        setReceiptVoucherNumber(preferences.receiptVoucherNumber);
        setPaymentVoucherNumber(preferences.paymentVoucherNumber);
        setDueDays(preferences.dueDays);
    }, [preferences]);

    return (
        <div className="card">
            <div className="card-body w-100">
                <div className="content-page-header">
                    <h5>Preference Settings</h5>
                </div>
                <form onSubmit={handleSubmit} className="row">
                    <h5 className="mail-title">Tax Settings</h5>
                    <div className="col-lg-6 col-12">
                        <div className="input-block mb-3">
                            <div className="mail-provider">
                                <h4>TCS</h4>
                                <div className="mail-setting">
                                    <div className="status-toggle">
                                        <input
                                            id="tcs"
                                            className="check"
                                            name="tcs"
                                            type="checkbox"
                                            checked={tcs}
                                            onChange={(e) => setTcs(e.target.checked)}
                                        />
                                        <label htmlFor="tcs" className="checktoggle checkbox-bg">
                                            checkbox
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-12">
                        <div className="input-block mb-3">
                            <div className="mail-provider">
                                <h4>TDS</h4>
                                <div className="mail-setting">
                                    <div className="status-toggle">
                                        <input
                                            id="tds"
                                            className="check"
                                            type="checkbox"
                                            checked={tds}
                                            name={'tds'}
                                            onChange={(e) => setTds(e.target.checked)}
                                        />
                                        <label htmlFor="tds" className="checktoggle checkbox-bg">
                                            checkbox
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h5 className="mail-title">Charge Settings</h5>
                    <div className="col-lg-6 col-12">
                        <div className="input-block mb-3">
                            <div className="mail-provider">
                                <h4>Transportation Charge</h4>
                                <div className="mail-setting">
                                    <div className="status-toggle">
                                        <input
                                            id="transportation"
                                            className="check"
                                            type="checkbox"
                                            name={'transportation'}
                                            checked={transportation}
                                            onChange={(e) => setTransportation(e.target.checked)}
                                        />
                                        <label htmlFor="transportation" className="checktoggle checkbox-bg">
                                            checkbox
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-12">
                        <div className="input-block mb-3">
                            <div className="mail-provider">
                                <h4>Labour Charge</h4>
                                <div className="mail-setting">
                                    <div className="status-toggle">
                                        <input
                                            id="labour"
                                            className="check"
                                            type="checkbox"
                                            checked={labour}
                                            name={'labour'}
                                            onChange={(e) => setLabour(e.target.checked)}
                                        />
                                        <label htmlFor="labour" className="checktoggle checkbox-bg">
                                            checkbox
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h5 className="mail-title">Quantity Settings</h5>
                    <div className="col-12">
                        <div className="input-block mb-3">
                            <div className="mail-provider">
                                <h4>Quantity</h4>
                                <div className="mail-setting">
                                    <div className="status-toggle">
                                        <input
                                            id="quantity"
                                            className="check"
                                            type="checkbox"
                                            checked={quantity}
                                            name={'quantity'}
                                            onChange={(e) => setQuantity(e.target.checked)}
                                        />
                                        <label htmlFor="quantity" className="checktoggle checkbox-bg">
                                            checkbox
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h5 className="mail-title">Numbering Setting</h5>
                    <div className="col-lg-6 col-12">
                        <div className="input-block mb-3">
                            <label>Invoice Number</label>
                            <input
                                type="text"
                                pattern={'.*\\d$'}
                                className="form-control"
                                placeholder="Enter invoice number"
                                value={invoiceNumber}
                                name={'invoiceNumber'}
                                onChange={(e) => setInvoiceNumber(e.target.value)}
                                required={true}
                            />
                        </div>
                    </div>
                    <div className="col-lg-6 col-12">
                        <div className="input-block mb-3">
                            <label>Purchase Number</label>
                            <input
                                type="text"
                                pattern={'.*\\d$'}
                                className="form-control"
                                placeholder="Enter purchase number"
                                value={purchaseNumber}
                                name={'purchaseNumber'}
                                onChange={(e) => setPurchaseNumber(e.target.value)}
                                required={true}
                            />
                        </div>
                    </div>
                    <div className="col-lg-6 col-12">
                        <div className="input-block mb-3">
                            <label>Credit Note Number</label>
                            <input
                                type="text"
                                pattern={'.*\\d$'}
                                className="form-control"
                                placeholder="Enter credit note number"
                                name={'creditNoteNumber'}
                                value={creditNoteNumber}
                                onChange={(e) => setCreditNoteNumber(e.target.value)}
                                required={true}
                            />
                        </div>
                    </div>
                    <div className="col-lg-6 col-12">
                        <div className="input-block mb-3">
                            <label>Debit Note Number</label>
                            <input
                                type="text"
                                pattern={'.*\\d$'}
                                className="form-control"
                                placeholder="Enter debit note number"
                                name={'debitNoteNumber'}
                                value={debitNoteNumber}
                                onChange={(e) => setDebitNoteNumber(e.target.value)}
                                required={true}
                            />
                        </div>
                    </div>
                    <div className="col-lg-6 col-12">
                        <div className="input-block mb-3">
                            <label>Receipt Voucher Number</label>
                            <input
                                type="text"
                                pattern={'.*\\d$'}
                                className="form-control"
                                placeholder="Enter receipt voucher number"
                                name={'receiptVoucherNumber'}
                                value={receiptVoucherNumber}
                                onChange={(e) => setReceiptVoucherNumber(e.target.value)}
                                required={true}
                            />
                        </div>
                    </div>
                    <div className="col-lg-6 col-12">
                        <div className="input-block mb-3">
                            <label>Payment Voucher Number</label>
                            <input
                                type="text"
                                pattern={'.*\\d$'}
                                className="form-control"
                                placeholder="Enter payment voucher number"
                                name={'paymentVoucherNumber'}
                                value={paymentVoucherNumber}
                                onChange={(e) => setPaymentVoucherNumber(e.target.value)}
                                required={true}
                            />
                        </div>
                    </div>
                    <h5 className="mail-title">Due Setting</h5>
                    <div className="col-12">
                        <div className="input-block mb-3">
                            <label>Due Days</label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Enter due days"
                                name={'dueDays'}
                                value={dueDays}
                                onChange={(e) => setDueDays(parseInt(e.target.value))}
                                required={true}
                            />
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="btn-path text-end">
                            <a
                                href="javascript:void(0);"
                                className="btn btn-cancel bg-primary-light me-3"
                                onClick={() => {
                                    setTcs(preferences.tcs);
                                    setTds(preferences.tds);
                                    setTransportation(preferences.transportationCharge);
                                    setLabour(preferences.labourCharge);
                                    setQuantity(preferences.quantity);
                                    setInvoiceNumber(preferences.invoiceNumber);
                                    setPurchaseNumber(preferences.purchaseNumber);
                                    setCreditNoteNumber(preferences.creditNoteNumber);
                                    setDebitNoteNumber(preferences.debitNoteNumber);
                                    setDueDays(preferences.dueDays);
                                }}
                            >
                                Cancel
                            </a>
                            <button type="submit" className="btn btn-primary">
                                Save Changes
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default PreferenceSettings;
